import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

const SKELETON_COUNT = 4;

const AgentCardSkeleton: React.FC = () => (
  <Card className="h-full rounded-lg bg-card">
    <CardContent className="flex h-full flex-col p-4 md:p-6">
      <Skeleton className="mb-4 h-6 w-3/4 border-b border-border pb-4" />
      <div className="mt-auto flex flex-col gap-3">
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-5/6" />
        <Skeleton className="h-4 w-2/3" />
      </div>
    </CardContent>
  </Card>
);

const AgentsListSkeleton: React.FC = () => (
  <div className="grid w-full grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
    {Array.from({ length: SKELETON_COUNT }).map((_, index) => (
      <AgentCardSkeleton key={index} />
    ))}
  </div>
);

export default AgentsListSkeleton;
